import React from "react";
import { Row, Col, Table } from "react-bootstrap"
import { PropTypes } from 'prop-types'
import "react-table/react-table.css"
import { videoblue } from '../../../utils/constants'

class FeesTable extends React.Component {
  constructor() {
    super();
    this.state = {
      changedRecords:[]
    }
    this.handleFeesChange   = this.handleFeesChange.bind(this)
  }

  handleFeesChange(evt){
    const { changedRecords } = this.state   
    const { onFeesSave } = this.props
    const divisionId = evt.target.id;
    const spotFeeVal = evt.target.innerHTML; 

    const newDivision = {
      Id:divisionId,
      SpotFee:spotFeeVal
    };

    const currentIndex = changedRecords.map(function(e) { return e.Id; }).indexOf(divisionId);

    if (currentIndex === -1){
      changedRecords.push(newDivision);
    } else {
      changedRecords[currentIndex] = newDivision
    }

    this.setState({
      changedRecords
    });

    onFeesSave(changedRecords);
  }

  render()
   {  
    const { divisions, onFeesChange } = this.props
    const divisionExist = (divisions !== undefined && divisions !== null) && (divisions.length > 0)

    return (
      (divisionExist) && (<Row>
      <Col xs={5}>
        <Table striped>
          <thead>
            <tr>
              <th>Division</th>
              <th>Name</th>
              <th>Spot Fees</th>
            </tr>
          </thead>
          <tbody>
            {
              (divisions !== undefined) && divisions.map((item, key) => (          
                <tr key={key}>
                  <td>{key + 1}</td>
                  <td>{item.name}</td>
                  <td><div contentEditable="true" id={item.id} style={{ border:`1px solid ${videoblue}` }} onInput={onFeesChange} onBlur={this.handleFeesChange}>{item.spotFee}</div></td>                 
                </tr>
              ))
            }
          </tbody>
        </Table>
      </Col>
    </Row>))
  }
}
FeesTable.propTypes = { 
  divisions: PropTypes.object,
  onFeesSave: PropTypes.func,
  onFeesChange: PropTypes.func
}
export default FeesTable



// WEBPACK FOOTER //
// ./src/containers/season/components/FeesTable.js